export class ProPerspectivePersonEntity{
    id:number;
    perspectiveId:number;
    personId:number;

    constructor(){}
}